import { KnownSortOrder, OrderDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useCallback } from 'react';
import { ProjectPathParams, Paths } from '../../../../../app/router/app.router';
import {
  InfiniteScrollProps,
  InfiniteTable,
  PaginatedRow
} from '../../../../../ui/components/pure/list-table-wrappers/infinite-table.component';
import { createOrderDetailsPageUrl } from '../../../orders.utils';
import { useOrdersTable } from '../../hooks/use-orders-table.hook';

interface OrdersTableProps {
  params: ProjectPathParams<Paths.orders>;
  pages: PaginatedRow<OrderDto>[];
  infiniteScroll: InfiniteScrollProps;
  setFormData: (update: any) => void;
  sortData: { sortBy: string; sortOrder: KnownSortOrder };
  isLoading: boolean;
  isPreviousData: boolean;
  showHubName?: boolean;
  hasError: boolean;
}

export const OrdersTable = function OrdersTable({
  params,
  pages,
  infiniteScroll,
  setFormData,
  sortData,
  isLoading,
  isPreviousData,
  hasError,
  showHubName = false
}: OrdersTableProps) {
  const mapRowURL = useCallback(
    (row: OrderDto) => createOrderDetailsPageUrl(row, params.shortcode ?? params.projectID),
    [params.projectID, params.shortcode]
  );

  const currentPath = document.location;
  const tableLocationState = { from: { search: currentPath.search, pathname: currentPath.pathname } };

  const tb = useOrdersTable({ projectID: params.projectID });

  tb.config({ mapRowURL });
  tb.config({ tableLocationState });
  tb.addPredicate('HUB', () => showHubName);

  return (
    <InfiniteTable
      uniqueKey="id"
      onSort={setFormData}
      sortData={sortData}
      table={tb}
      pages={pages}
      infiniteScroll={infiniteScroll}
      isLoading={isLoading}
      isPreviousData={isPreviousData}
      hasError={hasError}
    />
  );
};
